import { useArenaStore } from "../../stores/useArenaStore";
import type { ArenaState } from "@shared/types";

interface RespawnOverlayProps {
  state: ArenaState;
}

export function RespawnOverlay({ state }: RespawnOverlayProps) {
  const { playerId } = useArenaStore();
  const me = state.players.find((p) => p.id === playerId);

  if (!me) return null;

  if (state.phase === "finished") {
    const winner =
      state.score.dawn === state.score.dusk
        ? "It's a draw!"
        : state.score.dawn > state.score.dusk
          ? "☀️ Dawn Legion wins!"
          : "🌙 Dusk Horde wins!";
    const iWon =
      (state.score.dawn > state.score.dusk && me.faction === "dawn") ||
      (state.score.dusk > state.score.dawn && me.faction === "dusk");
    return (
      <div className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-black/70 backdrop-blur">
        <div className={`text-5xl font-black ${iWon ? "text-dawn-400" : "text-red-400"}`}>
          {winner}
        </div>
        <div className="mt-4 text-xl text-archer-300">
          Final Score: {state.score.dawn} — {state.score.dusk}
        </div>
        <div className="mt-2 text-sm text-archer-500">
          You: {me.kills} kills · {me.deaths} deaths · Lv.{me.level}
        </div>
        <button
          onClick={() => window.location.reload()}
          className="mt-8 rounded-xl bg-gradient-to-r from-dawn-600 to-dusk-600 px-8 py-3 font-bold text-white hover:brightness-110"
        >
          Play Again
        </button>
      </div>
    );
  }

  if (me.isDead && me.respawnAt !== null) {
    const remaining = Math.max(0, me.respawnAt - Date.now());
    const secs = Math.ceil(remaining / 1000);
    return (
      <div className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm">
        <div className="text-4xl font-black text-red-400">You were slain</div>
        <div className="mt-4 text-2xl font-mono text-white">{secs}s</div>
        <div className="mt-2 text-sm text-archer-300">Respawning...</div>
      </div>
    );
  }

  return null;
}
